import React from 'react';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import '../css/patientsForm.css'
import BMSParticipantForm from '../forms/BMSParticipantForm';
import {bmsLogo, headerImg, patientSupportIcon, nurseIcon, doctorIcon, readerIcon} from '../components/Images';
import { APPROVAL_FOOTER, CONSENT_CODE } from '../config/lrApproval';

// Variables de entorno para reCAPTCHA
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const ENABLE_CAPTCHA = process.env.REACT_APP_ENABLE_CAPTCHA === "true";

function BMSPublicFormPageContent() {
    return (
        <div className="patient-content">
        <div className="patient-header">
            <div className="header-image-container">
                <img src={headerImg} alt="Encabezado" className="header-image" />
            </div>
            <div className="header-icon-container">
                <img src={patientSupportIcon} className="header-icon" alt="" />
            </div>
            <div className="header-content">
                <h1 className="header-content-info">Vamos <span className="text-color">Contigo</span></h1>
                <h2 className="header-content-info">Programa Soporte a <span className="text-color">Pacientes</span></h2>
                <hr className="dotted-div" />
                <h3 className="header-content-info" >Beneficios</h3>
            </div>
        </div>

        <div className="patient-content-container">

            <div className="patient-content-section">
                <div className="patient-info-section">
                    <ul className="patient-info-list">
                        <li className="patient-info-item">
                            <div className="patient-icon-container">
                                <img src={readerIcon} className="list-icon" alt="" />
                            </div>
                            <div className="patient-info-desc">
                                Programa de educación para el paciente y su cuidador, con materiales educativos para entender la enfermedad y aprender a sobrellevarla.
                            </div>
                        </li>
                        <li className="patient-info-item">
                            <div className="patient-icon-container">
                                <img src={doctorIcon} className="list-icon" alt="" />
                            </div>
                            <div className="patient-info-desc">
                                Contact center - Con educación, orientación y asesoramiento desde la prescripción del medicamento una vez realizada por el médico tratante.
                            </div>
                        </li>
                        <li className="patient-info-item">
                            <div className="patient-icon-container">
                                <img src={nurseIcon} className="list-icon" alt="" />
                            </div>
                            <div className="patient-info-desc">
                                Seguimiento a la adherencia del paciente a través de enfermeras profesionales de manera periódica una vez inscrito en el programa.
                            </div>
                        </li>
                    </ul>
                </div>
                <div className='inform-consent-section'>
                    <p>
                        <span className='consent-subtitle'>Consentimiento informado: </span>
                        Manifiesto libre y expresamente mi interés en recibir información detallada sobre los servicios del programa de apoyo a pacientes VAMOS CONTIGO, por lo tanto, mediante la aceptación de este documento, autorizo al prestador de servicios del Programa de Apoyo a Pacientes basado en Colombia a tratar mis datos personales aquí consignados (nombre, número de teléfono y país de residencia), con la finalidad de contactarme vía telefónica para brindarme la información correspondiente al servicio que prestan.  Reconozco que este operador tiene filiales y equipos en múltiples países, por lo tanto, lo autorizo para almacenar y transferir la información personal o hacerla accesible desde fuera de mi país de residencia, manteniendo la información personal segura y confidencial, para lo cual utilizará acuerdos y medios seguros. 
                    </p>
                    <p>
                        Así mismo, entiendo que esta aceptación en ningún momento autoriza mi ingreso al programa de pacientes.
                    </p>
                    <p>
                    Reconozco los derechos que me asisten en calidad de Titular de mis datos personales previstos en la Ley colombiana 1581 de 2012, el Decreto 1377 de 2013 y demás normas vigentes que reglamenten la materia en mi país de residencia.
                    <span className='consent-code'> {CONSENT_CODE}</span>
                    </p>
                    

                </div>
            </div>
            <div className="patient-content-section patient-content-section-form">
                <BMSParticipantForm />
            </div>

        </div>
        <div className="patient-content-footer">
            <div className='footer-content'>
                <div className='footer-text'>
                    <div>Material dirigido a pacientes</div>
                    <div>{APPROVAL_FOOTER}</div>
                </div>
                <div className="footer-logo">
                    <img src={bmsLogo}  alt="" />
                </div>
            </div>
            
            <hr className="footer-bar" />
        </div>
    </div>
    );
}

// Componente exportado que envuelve condicionalmente con GoogleReCaptchaProvider
function BMSPublicFormPage() {
    if (!ENABLE_CAPTCHA) {
        return <BMSPublicFormPageContent />;
    }

    return (
        <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
            <BMSPublicFormPageContent />
        </GoogleReCaptchaProvider>
    );
}

export default BMSPublicFormPage;
